const styles = theme => ({
  snack : {
    backgroundColor: theme.palette.success.main
  },
  snackError : {
    backgroundColor: theme.palette.error.main
  }
});

export default styles;